<template>
  <div class="hello">
    <div id="hero_content">
      
      <img src="../../static/logo.png" style="max-width:330px"/>
      <h3>A platform for instant answers to your Quant, Verbal, Logic & DI questions</h3>
      <div class="cta">
        <b-button variant="primary" size="lg" to="/login">Login</b-button>
        <b-button to="/signup" size="lg">Sign Up</b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to QdsPro'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  text-align:center;
  background-color: #262f3c;
  height:100vh;
  display:flex;
  align-items: center;
}

#hero_content {
  max-width:500px;
  margin:auto;
  color:white;
}
.cta {
  padding: 30px
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue